import { TransactionResult } from '@safe-global/types-kit'
import axios from 'axios'

export const axiosClient = axios.create({
  baseURL:
    'https://lsjtacsde5uprptnvbbmqjvo5u0rvljq.lambda-url.us-east-1.on.aws/',
})

export const deploySafe = ({
  ownerAddress,
  threshold,
  chainId,
}: {
  ownerAddress: string
  threshold: number
  chainId: number
}) => {
  return axiosClient
    .post<{
      data: {
        address: string
        transactionHash: string
      }
    }>('/safe/deploy', {
      ownerAddress,
      threshold,
      chainId,
    })
    .then(res => res.data)
}

export const executeProposedTransaction = ({
  ownerAddress,
  signature,
  chainId,
  safeAddress,
  to,
  value,
  data,
  operation,
  baseGas,
  gasPrice,
  gasToken,
  refundReceiver,
  safeTxGas,
  nonce,
}: {
  ownerAddress: string
  signature: string
  chainId: number
  safeAddress: string
  to: string
  value: string
  data: string
  operation: number
  baseGas: string
  gasPrice: string
  gasToken: string
  refundReceiver: string
  safeTxGas: string
  nonce: number
}) => {
  return axiosClient
    .post<{
      data: TransactionResult
    }>('/safe/execute', {
      ownerAddress,
      signature,
      chainId,
      safeAddress,
      operation,

      to,
      value,
      data,
      baseGas,
      gasPrice,
      gasToken,
      refundReceiver,
      safeTxGas,
      nonce,
    })
    .then(res => res.data)
}
